import React from 'react';
import { makeStyles, Checkbox, Button } from '@material-ui/core';
import { TriggersTooltips } from '../../../TriggersTooltip';
export interface ISearchableChecklistItem {
    content: React.ReactNode;
    selected: boolean;
    disabled?: boolean;
    keywords: string;
    hide?: boolean;
    errors: any[];
    hasFrame?: boolean;
    id?: string;
    changed?: boolean;
    itemToolbar?: (id: string, getSelected: () => ISearchableChecklistItem[]) => JSX.Element;
    name_public?: string;
    sub_title?: string;
    [key: string]: any;
    title?: string | React.ReactChild;
    hasTooltip?: boolean;
    contentClassName?: string;
}

interface ISearchableChecklistItemProps extends ISearchableChecklistItem {
    index: number;
    onCheckboxChange: (checked: boolean, index: number) => void;
    hide?: boolean;
    getSelected?: () => ISearchableChecklistItem[];
}

const SearchableChecklistItem = (props: ISearchableChecklistItemProps) => {
    const useStyles = makeStyles({
        wrapper: {
            display: 'block',
            textAlign: 'left',
            textTransform: 'capitalize',
            width: '100%',
            border: props.hasFrame ? '1px solid #E8EAF4' : 'none',
            borderRadius: '14px',
            padding: props.hasFrame ? '0.8rem' : '0',
            transition: '0.25s ease-in-out',
            '&:hover': {
                backgroundColor: props.hasFrame ? '#F3F4F988' : '#F3F4F9',
            },
            '&:active': {
                backgroundColor: '#F3F4F9DD',
            },
            '& .MuiTouchRipple-rippleVisible': {
                color: '#D7DAE6 !important',
            },
            '&.error': {
                backgroundColor: '#FAFBFD',
                border: '1px solid #FAFBFD',
                color: '#737FA4',
            },
        },
        contentWrapper: {
            display: 'flex',
            alignItems: 'center',
            padding: '0.625rem',
        },
        content: {
            flexGrow: 1,
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
        },
        itemToolbar: {
            display: 'flex',
            flexDirection: 'row-reverse',
            padding: '0 1rem',
            alignItems: 'center',
            '@media only screen and (max-width: 767px)': {
                width: '100%',
                marginTop: '1rem',
            },
        },
        selected: {
            border: props.hasFrame ? '1px solid #FFDD02' : 'none',
        },
        checkbox: {
            color: '#F3F4F9',
            transition: '0.2s ease-in-out',
            '&.Mui-checked': {
                color: '#FFDD02',
            },
        },
    });

    const classes = useStyles();

    const handleChange = () => {
        if (!props.disabled) props.onCheckboxChange(!props.selected, props.index);
    };
    if (props.hide) return null;

    return (
        <TriggersTooltips title={props.title ? props.title : ''} disabled={props.disabled && props.hasTooltip}>
            <Button
                onClick={handleChange}
                className={`${classes.wrapper} ${props.errors?.length > 0 ? 'error' : ''} ${
                    props.selected ? classes.selected : ''
                }`}
                disabled={props.errors?.length > 0}
                data-component-name="SearchableCheckListItem"
            >
                <div className={classes.contentWrapper}>
                    <span>
                        <Checkbox className={classes.checkbox} checked={props.selected} color={'primary'} />
                    </span>
                    <span className={`${classes.content} ${props.contentClassName && props.contentClassName}`}>
                        {props.content}
                    </span>
                    {props.itemToolbar && props.id && props.getSelected && (
                        <span className={classes.itemToolbar}>{props.itemToolbar(props.id, props.getSelected)}</span>
                    )}
                </div>
            </Button>
        </TriggersTooltips>
    );
};

SearchableChecklistItem.defaultProps = {
    hasFrame: true,
} as Partial<ISearchableChecklistItemProps>;

export default SearchableChecklistItem;
